module.exports = __webpack_public_path__ + "img/chevrons-up.ca9b1d7e.svg";